import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { Button } from './ui/Button';
const NAV_LINKS = [{
  label: 'Case Studies',
  to: '/#work'
}, {
  label: 'Services',
  to: '/#services'
}, {
  label: 'About us',
  to: '/#studio'
}, {
  label: 'Blog',
  to: '/blog'
}];
const BLUE_WHITE_LOGO = 'https://cdn.magicpatterns.com/uploads/4dE9fLpUrJZPexP4Wa8YZa/Layer_1.svg';
const RED_BLUE_LOGO = 'https://cdn.magicpatterns.com/uploads/sNZFX96gk6B4kDQMv3FNfR/Full_color.png';
export function Navbar() {
  const [open, setOpen] = useState(false);
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname, hash]);
  const textColor = 'text-[#595959] hover:text-[#2D2D2D]';
  return <header className="fixed left-1/2 top-4 z-50 w-[calc(100%-2rem)] max-w-shell -translate-x-1/2 rounded-full bg-white shadow-md transition-all duration-300" data-id="element-137" data-mp="1py1i9kejx83c">
      <div className="flex w-full items-center justify-between gap-6 px-5 py-3 lg:px-8" data-id="element-138" data-mp="9ohl1o43rnsk">
        <Link to="/" aria-label="Yetu Design Lab home" className="shrink-0" data-id="element-139" data-mp="9qtzvsekdi1e">
          <img src={RED_BLUE_LOGO} alt="Yetu Design Lab" className="h-9 w-auto object-contain" data-id="element-140" data-mp="elpsourmk9fk" />
        </Link>

        <nav aria-label="Main" className="hidden items-center gap-8 lg:flex" data-id="element-141" data-mp="om9vi1usllzw">
          {NAV_LINKS.map(link => <Link key={link.label} to={link.to} className={`text-sm font-medium transition-colors ${textColor}`} data-id="element-142" data-mp="3n4fb190xctqc">
              {link.label}
            </Link>)}
        </nav>

        <div className="hidden lg:block" data-id="element-143" data-mp="ub9amtt267z">
          <Button to="/#contact" variant="solid" className="!py-3 !text-sm" data-id="element-144" data-mp="5n4ch69ml6hy">
            Book Free Consultation
          </Button>
        </div>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} className="rounded-full p-2 text-[#2D2D2D] lg:hidden" data-id="element-145" data-mp="34as4ilcwyiok">
          {open ? <XIcon className="h-6 w-6" data-id="element-146" data-mp="2wa3wo59p0om4" /> : <MenuIcon className="h-6 w-6" data-id="element-147" data-mp="3b01hqccbsy73" />}
        </button>
      </div>

      {open && <div id="mobile-nav" className="absolute left-0 top-full mt-2 w-full rounded-2xl bg-white p-5 shadow-xl lg:hidden" data-id="element-148" data-mp="3631e082y87j5">
          <nav aria-label="Mobile" className="flex flex-col" data-id="element-149" data-mp="2ddc9hkr15pcs">
            {NAV_LINKS.map(link => <Link key={link.label} to={link.to} onClick={() => setOpen(false)} className="border-b border-[#D9D9D9] py-3 text-base font-medium text-[#2D2D2D]" data-id="element-150" data-mp="2salbr9hvgdja">
                {link.label}
              </Link>)}
          </nav>
          <div className="pt-5" data-id="element-151" data-mp="2m2mjcx6hgun">
            <Button to="/#contact" variant="solid" fullWidth data-id="element-152" data-mp="2krhzavws52h">
              Book Free Consultation
            </Button>
          </div>
        </div>}
    </header>;
}